__webpack_require__.p = "https://static.spqr.app/40ddad2b16fd542f73ea274a09cbd827a85e7b03/_next/";